module.exports = __webpack_public_path__ + "img/avatar6.dc1a2720.png";